// eslint-disable-next-line import/extensions
import store from '~/store'

export default async (to, from, next) => {
	// Only apply this guard to the ask-stanley route
	if (to.name === 'ask_stanley' || to.name === 'AskStanleyIndex') {
		const user = store.getters['Auth/user']

		// Check if user exists and is authenticated
		if (!user) {
			next()
			return
		}

		// Check if user has the test experiment flag
		if (user.has_dynamic_dashboard) {
			// Open the ChatOverlay instead of navigating to the route
			store.dispatch('Chat/openChatOverlay')

			// Redirect to dashboard or stay on current page
			if (from.name && from.name !== 'dashboard') {
				next({ name: from.name, replace: true })
			} else {
				next({ name: 'dashboard', replace: true })
			}
		} else {
			// Continue with normal navigation
			next()
		}
	} else {
		// For all other routes, continue normally
		next()
	}
}
